import {
  Tooltip,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IResultadoItem } from "../../../model";
import {
  MDBBtn,
} from "mdbreact";
import { AppStore } from "../../../stores/AppStore";
import { ResultadoStore } from "../../../stores/resultados/ResultadoStore";
import { CTEItemDialog } from "./item-detail/ItemDialogCTE";
import BootstrapTable from "react-bootstrap-table-next";
import { columns_cte } from "../../utils/TableDetalhamento"

interface Props {
  items: any[];
  entrada_saida: string;
  modelo: string;
}

@observer
export class DetalhamentoCteTable extends React.Component<Props, {}> {

  obs = observable({
    new_columns: columns_cte,
    viewing: null as IResultadoItem
  })

  handleContest(item: IResultadoItem) {

    ResultadoStore.obs.contestarItems = []

    this.onSelect(item, true)

    ResultadoStore.obs.openContestacaoLote = true;

  }

  handleView(item: any) {
    this.obs.viewing = item;
  }

  handleViewClose = () => {
    this.obs.viewing = null;
  };

  renderViewDialog() {
    return (
      <CTEItemDialog
        modelo={this.props.modelo}
        item={this.obs.viewing}
        entrada_saida={this.props.entrada_saida}
        onClose={this.handleViewClose}
      />
    );
  }

  componentDidMount() {
    let temp_table: any = [];
    ResultadoStore.handldeItensProcessando();

    temp_table = [
      {
        dataField: 'info',
        text: 'Detalhes',
        headerStyle: { width: '5%' },
        formatter: (cell, row) => {
          return (this.buttonFormatterDetalhes(cell, row))
        },
      },
      {
        dataField: 'contestar',
        text: 'Contestar',
        formatter: (cell, row) => {
          return (this.buttonFormatterContestar(cell, row))
        },
      }
    ]

    this.obs.new_columns = columns_cte.concat(temp_table)
  }

  buttonFormatterDetalhes = (cell, row) => {

    return (
      <MDBBtn rounded size="sm" onClick={() => this.handleView(row.any_item)}>
        <img src="/images/contestar.svg" width={20} />
      </MDBBtn>
    );
  };

  buttonFormatterContestar = (cell, row) => {

    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

    let isDisabled = niveis_acesso.indexOf("c2") == -1

    if (AppStore.obs1.usuario) {

      if (ResultadoStore.obs.itens_processando.indexOf(row.id) != -1) {

        return (
          <>

            <MDBBtn rounded size="sm">
              <Tooltip content={"Processando"}>
                <img src="/images/icone-relogio.png" width={25} />
              </Tooltip>
            </MDBBtn>

          </>
        )
      }

      return (
        <>

          <MDBBtn rounded size="sm" onClick={() => this.handleContest(row.any_item)} disabled={isDisabled}>
            <Tooltip content={row.any_item.contestacao_calc_id ? "Item contestado" : "Contestar"}>
              {row.any_item.contestacao_calc_id
                ? <img src="/images/contestado.png" width={20} />
                : <img src="/images/contestar.png" width={20} />}
            </Tooltip>
          </MDBBtn>

        </>

      );

    }

  };

  onSelectAll = async (isSelect, rows) => {

    if (isSelect) {
      let data = rows?.map(value => {
        return {
          id: value.id,
          data: value.data
        }
      })
      ResultadoStore.setContestarItemsList(data);
    } else {
      ResultadoStore.resetContestarItems();
    }
  };

  onSelect = async (item, checked) => {

    let data = {
      id: item._id || item.id,
      data: item.data
    }
    if (checked) {
      ResultadoStore.setContestarItems(data);
    } else {
      ResultadoStore.deleteByIdContestarItems(item.id);
    }
  }

  render() {

    let items = this.props.items?.map((item) => {

      return (
        {
          id: item._id,
          any_item: item,
          serie_nota: item.serie + "/" + item.numero,
          chave: item.chave,
          data: item.data,
          cnpj_emitente: this.props.entrada_saida == "Saída" ? item.cnpj_destino : item.cnpj_origem,
          cfop: item.cfop,
          cest: item.cst,
          calculo: item.calc,
          valor: item.valor,
          valor_pagar: item.valor_icms_ant,
          info: item
        }
      );
    });

    const selectRowProp = {
      mode: 'checkbox',
      clickToSelect: false,
      style: { backgroundColor: '#e9f6ff' },
      onSelectAll: this.onSelectAll,
      selected: ResultadoStore.obs.contestarItems?.map(value => value.id),
      onSelect: this.onSelect,
      nonSelectable: ResultadoStore.obs.itens_processando,
    };

    return (
      <>

        {/* @ts-ignore */}
        <BootstrapTable keyField="id" className="TableDefault" data={items} columns={this.obs.new_columns} selectRow={selectRowProp} rowClasses={this.handleTrClassFormat} hover />

        {this.obs.viewing && this.renderViewDialog()}
      </>
    );
  }
}

export default DetalhamentoCteTable;
